import React from "react";

const STATS = [
  { value: "100+", label: "Systems integrated" },
  { value: "99.9%", label: "Avg. uptime delivered" },
  { value: "24/7", label: "Support coverage" },
  { value: "15+", label: "Industries served" },
];

export default function Stats() {
  return (
    <section className="py-5" style={{ background: "var(--navy)" }}>
      <div className="container">
        <div className="row text-center g-4">
          {STATS.map((s) => (
            <div className="col-6 col-md-3" key={s.label}>
              <div className="display-font" style={{ fontSize: "2.4rem", fontWeight: 600, color: "#5fe6cf" }}>
                {s.value}
              </div>
              <div className="mono-label" style={{ color: "rgba(255,255,255,0.65)" }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
